import { useLocation } from "react-router-dom";
import { isAppShellPath } from "./isAppShellPath";

export const useIsAppShell = (): boolean => isAppShellPath(useLocation().pathname);
